import { JSX } from 'react';
import { appContext } from '../../../../AppContext';
import { IOntologyNodeParameter } from './OntologyNodeParametersCard';
import { IbssComponent } from '../../../../Components/Core/BaseComponent/IbssComponent';
import { Button, ButtonBar, Card, Dialog, DialogContent, DialogFooter, GridContainer, GridItem, RightButtons, TextField } from '@iconics/components';

class EditOntologyNodeParameterDialog extends IbssComponent<IProps, IState>
{
    private get labels() { return appContext().labels; }

    constructor(props: IProps)
    {
        super(props);
        this.state =
        {
            id: '',
            valueType: '',
            value: '',
            concurrencyToken: ''
        };
    }

    public componentDidUpdate(prevProps: Readonly<IProps>): void
    {
        if (!prevProps.open && this.props.open)
        {
            this.handleOpen();
        }
    }

    private handleOpen(): void
    {
        if (!this.props.ontologyNodeParameter)
        {
            this.setState({
                id: '',
                valueType: '',
                value: '',
                concurrencyToken: ''
            });
        }
        else
        {
            this.setState({
                id: this.props.ontologyNodeParameter.id,
                valueType: this.props.ontologyNodeParameter.valueType,
                value: this.props.ontologyNodeParameter.value,
                concurrencyToken: this.props.ontologyNodeParameter.concurrencyStamp,
            });
        }
    }

    private handleCancel(): void
    {
        this.props.onClose();
    }

    private async handleSave(): Promise<void>
    {
        await this.loading(async () => {
            if (this.props.ontologyNodeParameter)
            {
                await appContext().fadxPlatformApiClientV2.v2.core.byTenancy.nodes.byNodeid.ontologyNodes.byOntologyNodeId.parameters.put({
                    ontologyNodeId: this.props.ontologyNodeParameter?.ontologyNodeId,
                    nodeId: this.props.nodeId,
                    tenancy: this.props.tenancy,
                    body: [{
                        ID: this.state.id,
                        Value: this.state.value,
                        '@odata.etag': this.state.concurrencyToken,
                    }]
                        
                });
            }
            this.props.onSave();
        });
    }

    public render(): JSX.Element
    {
        return (
            <Dialog
                isOpen={this.props.open}
                onOpenChange={() => this.handleCancel()}
            >
                <DialogContent>
                    <Card
                        title={this.labels.Platform_Node_EditParameterTitle}
                        subTitle={this.labels.Platform_Node_EditParameterSubTitle}
                        details={this.labels.Platform_Node_EditParameterDetails}
                    >
                        <GridContainer>
                            <GridItem expanded={6}>
                                <TextField
                                    disabled
                                    label={this.labels.Parameter_ValueType}
                                    placeholder={this.labels.Parameter_ValueType}
                                    value={this.state.valueType}
                                />
                            </GridItem>
                            <GridItem expanded={6}>
                                <TextField
                                    label={this.labels.Parameter_Value}
                                    placeholder={this.labels.Parameter_Value}
                                    value={this.state.value}
                                    onChange={(e) => this.setState({ value: e.target.value })}
                                />
                            </GridItem>
                        </GridContainer>
                    </Card>
                </DialogContent>
                <DialogFooter>
                    <ButtonBar>
                        <RightButtons>
                            <Button
                                styleType='outlined'
                                onClick={() => this.handleCancel()}
                            >
                                {this.labels.Platform_CommonAction_Cancel}
                            </Button>
                            <Button
                                styleType='filled'
                                onClick={() => this.handleSave()}
                            >
                                {this.labels.Platform_CommonAction_Save}
                            </Button>
                        </RightButtons>
                    </ButtonBar>
                </DialogFooter>
            </Dialog>
        )
    }
}

export default EditOntologyNodeParameterDialog;

export interface IProps
{
    open: boolean;
    onClose: () => void;
    onSave: () => void;
    ontologyNodeParameter: IOntologyNodeParameter | undefined;
    nodeId: number;
    tenancy: string;
}

export interface IState
{
    id: string;
    valueType: string;
    value: string;
    concurrencyToken: string
}